import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../modules';

import ColorPicker from '../../components/ColorPicker/ColorPicker';
import Select from '../../components/Dropdown/Select';
import FieldSection from './FieldSection';
import SelectedSupportType from './SelectedSupportType';

type Props = {
	currentContent:any;
	styleTarget:string;
	currentContentStyle:any;
}

function SelectedContentStyle({ currentContent, styleTarget, currentContentStyle }:Props) {
	const editor = useSelector((state: RootState) => state.editor);

	return (
		<div className="editor-sidebar-selected-content-style">
			<FieldSection
				labelName="배경 색상"
			>
				<ColorPicker
					target={`${styleTarget}/box/background`}
					value={currentContentStyle?.box?.background}
					position="right"
				>배경</ColorPicker>	
			</FieldSection>

			<FieldSection
				labelName="배경 테두리"
			>
				<Select
					target={`${styleTarget}/box/borderWidth`}
					value={currentContentStyle?.box?.borderWidth}
					options={editor.option.borderWidth}
					size="small"
				/>
				<ColorPicker
					target={`${styleTarget}/box/borderColor`}
					value={currentContentStyle?.box?.borderColor}
					position="right"
				>테두리</ColorPicker>
			</FieldSection>

			{
				currentContent?.content?.category !== 'spacer' && (
					<>
					<h3 className="field-section-title">
						상자 여백
					</h3>

					<div className="box-padding-field">			
						<FieldSection
							labelName="내부 여백 상단"
							layout="vertical"
							labelSize="small"
						>
							<Select
								target={`${styleTarget}/box/paddingTop`}
								value={currentContentStyle?.box?.paddingTop}
								options={editor.option.boxPadding}
							/>				
						</FieldSection>
			
						<FieldSection
							labelName="내부 여백 하단"
							layout="vertical"
							labelSize="small"
						>
							<Select
								target={`${styleTarget}/box/paddingBottom`}
								value={currentContentStyle?.box?.paddingBottom}
								options={editor.option.boxPadding}
							/>
						</FieldSection>

						<FieldSection
							labelName="좌우 여백"
							layout="vertical"
							labelSize="small"
						>
							<Select
								target={`${styleTarget}/box/paddingLeft`}
								value={currentContentStyle?.box?.paddingLeft}
								options={editor.option.boxPadding}
							/>
						</FieldSection>
						
					</div>
					</>
				)
			}
			<SelectedSupportType currentContent={currentContent} />

		</div>
	);
}

export default SelectedContentStyle;